export default __webpack_public_path__ + "static/media/stairs.29575c43.svg";